export const appName = {
  clubHub: 'ClubHub',
  lenderHub: 'LenderHub',
  userManager: 'UserManager',
  igniteIntuitive: 'IgniteIntuitive',
  criteria: 'Criteria',
  propertyCriteria: 'PropertyCriteria',
  productCriteria: 'ProductCriteria',
};
